import React from 'react';
import {useSingleTheme} from '../../components/hooks/hooks-mongoDB/useSingleTheme';
import {useArticles} from '../../components/hooks/hooks-mongoDB/useArticles';
import {useParagraphs} from '../../components/hooks/hooks-mongoDB/useParagraphs';
import ThemesScreen from '../../components/modules/pannelli/ThemesScreen'
import {ABWHeadLinks} from '../../components/modules/pannelli/HeadLink';
import '../../components/modules/pannelli/themesScreen.scss';

function StoriaDelVino() {
    const {theme} = useSingleTheme('abruzzowines');
    const abruzzowines_Theme = theme;
    const {articles} = useArticles('abruzzowines');
    const article = articles.slice(0, 1) || [];
    const articles_Storia = article[0]; 
    const {paragraphs} = useParagraphs('abruzzowines_1');

    return (
        <section>
            {theme && <ABWHeadLinks title={abruzzowines_Theme.tema_titolo} /> }
            <ThemesScreen theme={abruzzowines_Theme} article={articles_Storia} paragraphs={paragraphs}/> 
        </section>
    )
}
export default StoriaDelVino;
